import { useState, useCallback, useEffect, useRef } from 'react';
import { FLAGS } from '../data/flags';
function shuffle(a){const b=[...a];for(let i=b.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[b[i],b[j]]=[b[j],b[i]];}return b;}
function makeOpts(c,all){return shuffle([c,...shuffle(all.filter(f=>f.name!==c.name)).slice(0,3)]);}
const TIME=4000;
export default function FlagFlash({onBack,best,setBest}){
  const TOTAL=15;
  const [phase,setPhase]=useState('home');
  const [round,setRound]=useState([]);
  const [ri,setRi]=useState(0);
  const [opts,setOpts]=useState([]);
  const [sel,setSel]=useState(null);
  const [score,setScore]=useState(0);
  const [streak,setStreak]=useState(0);
  const [timeLeft,setTimeLeft]=useState(TIME);
  const tick=useRef(null);
  const started=useRef(0);
  const start=useCallback(()=>{
    const r=shuffle(FLAGS).slice(0,TOTAL);
    setRound(r);setOpts(makeOpts(r[0],FLAGS));setRi(0);setSel(null);setScore(0);setStreak(0);setTimeLeft(TIME);setPhase('play');
  },[]);
  useEffect(()=>{
    if(phase!=='play'||sel!==null)return;
    started.current=Date.now();
    tick.current=setInterval(()=>{
      const left=TIME-(Date.now()-started.current);
      if(left<=0){clearInterval(tick.current);setSel('__timeout__');}
      else setTimeLeft(left);
    },50);
    return()=>clearInterval(tick.current);
  },[phase,ri,sel]);
  const next=useCallback(()=>{
    if(ri+1>=TOTAL){setPhase('over');return;}
    const ni=ri+1;setRi(ni);setOpts(makeOpts(round[ni],FLAGS));setSel(null);setTimeLeft(TIME);
  },[ri,round]);
  const pick=useCallback((name)=>{
    if(sel!==null)return;clearInterval(tick.current);setSel(name);
    const ok=name===round[ri].name;
    const ns=ok?score+1:score,nst=ok?streak+1:0;
    setScore(ns);setStreak(nst);if(ns>best)setBest(ns);
  },[sel,round,ri,score,streak,best,setBest]);
  const f=round[ri],answered=sel!==null,timed=sel==='__timeout__',ok=answered&&!timed&&f&&sel===f.name;
  const pct=(ri/TOTAL)*100,tpct=(timeLeft/TIME)*100;
  const timerCol=tpct>50?'#38bdf8':tpct>25?'#f5c518':'#ef4444';
  const grade=score>=14?'Flag Master':score>=11?'Geography Whiz':score>=8?'Decent Traveller':score>=5?'Map Reader':'Get An Atlas';
  const cc=(name)=>{if(!answered)return'choice hv-b';if(name===f.name)return'choice correct';if(name===sel)return'choice wrong';return'choice dim';};
  return(<div className="layer" style={{display:'flex',flexDirection:'column',minHeight:'100vh'}}>
    <div className="g-hdr">
      <button className="g-back" onClick={onBack}>← Menu</button>
      <div className="g-title blue">FLAG FLASH</div>
      {phase==='play'&&<div className="g-pills">
        <div className="g-pill b"><span className="g-plbl">Score</span><span className="g-pval">{score}</span></div>
        <div className="g-pill b"><span className="g-plbl">Streak</span><span className="g-pval">{streak}{streak>=3?'🔥':''}</span></div>
        <div className="g-pill"><span className="g-plbl">Best</span><span className="g-pval">{best}</span></div>
      </div>}
    </div>
    {phase==='home'&&<div className="game-home"><div className="game-inner">
      <div className="game-eye" style={{color:'#38bdf8',border:'1px solid #0369a1'}}>World Cup Nations</div>
      <h1 className="game-big" style={{color:'#38bdf8'}}>FLAG FLASH</h1>
      <p className="game-desc">Flag appears. Name the country.<br/><strong>4 seconds</strong> — pick from four choices.</p>
      {best>0&&<p className="game-best" style={{color:'#38bdf8'}}>Best: {best}/{TOTAL}</p>}
      <button className="btn-blue" style={{marginTop:8}} onClick={start}>KICK OFF</button>
    </div></div>}
    {phase==='over'&&<div className="game-home"><div className="over-card">
      <div className="over-tag" style={{color:'#38bdf8',border:'1px solid #0369a1'}}>FINAL WHISTLE</div>
      <h1 className="over-h1">{grade}</h1>
      <div className="over-stats">
        <div className="over-stat"><span className="over-num" style={{color:'#38bdf8'}}>{score}</span><span className="over-lbl">Correct</span></div>
        <div className="over-div"/>
        <div className="over-stat"><span className="over-num" style={{color:'#38bdf8'}}>{best}</span><span className="over-lbl">Best</span></div>
      </div>
      <button className="btn-blue" onClick={start}>PLAY AGAIN</button>
    </div></div>}
    {phase==='play'&&f&&<div className="game-body" style={{alignItems:'center'}}>
      <div className="prog-row" style={{width:'100%'}}><div className="prog-bar"><div className="prog-fill-b" style={{width:pct+'%'}}/></div><span className="prog-pct">{ri+1}/{TOTAL}</span></div>
      <div className="flag-timer"><div className="flag-timer-fill" style={{width:tpct+'%',background:timerCol}}/></div>
      <div className="flag-display"><div className="flag-big">{f.flag}</div></div>
      <p style={{fontSize:'0.82rem',color:'#8ba3cc'}}>Which country is this?</p>
      <div className="choices" style={{width:'100%'}}>{opts.map((o,i)=><button key={i} className={cc(o.name)} onClick={()=>pick(o.name)} disabled={answered}>{o.name}</button>)}</div>
      {answered&&<>
        <div className={'result-box '+(ok?'ok':'no')} style={{width:'100%'}}>
          <div className={'result-head '+(ok?'ok':'no')}>{timed?'Time up! It was '+f.name:ok?'Correct!':'It is '+f.name}</div>
        </div>
        <div className="game-actions" style={{width:'100%'}}>
          <span className="remaining">{ri+1<TOTAL?(TOTAL-ri-1)+' left':'Last one!'}</span>
          <button className="btn-next b" onClick={next}>{ri+1>=TOTAL?'Results →':'Next →'}</button>
        </div>
      </>}
    </div>}
  </div>);
}
